import Vue from 'vue'
import '@Shared/Lang'
import ContactForm from './Vue/ContactForm'
import AloIcon from '@App/Vue/Alo/Icon'
import AloLoadingRing from '@App/Vue/Alo/LoadingRing'

Vue.component('alo-icon', AloIcon)
Vue.component('alo-loading-ring', AloLoadingRing)
Vue.config.ignoredElements = ['trix-editor', 'teclia-trix-attachment']

import { meta } from '@App/Meta'
import axios from 'axios'
if (meta('app-url')) {
    if (meta('app-url-prefix')) {
        axios.defaults.baseURL = meta('app-url') + meta('app-url-prefix')
    } else {
        axios.defaults.baseURL = meta('app-url')
    }
}

/**
 * A inicialização do componente de formulário.
 */
window.TecliaContactForm = {
    mount(container) {
        let ComponentClass = Vue.extend(ContactForm)

        let instance = new ComponentClass({
            propsData: {
                workspaceId: container.getAttribute('data-workspace-id'),
                formToken: container.getAttribute('data-form-token'),
                departmentCode: container.getAttribute('data-department-code'),
                primaryColor: container.getAttribute('data-primary-color'),
            },
        })

        instance.$mount()
        container.appendChild(instance.$el)
    },
}

window.addEventListener('load', () => {
    Array.from(document.querySelectorAll('[data-teclia-form]')).forEach(node => {
        window.TecliaContactForm.mount(node)
    })
})
